import { CheckIcon, CrossIcon } from '@mentimeter/ragnar-visuals';
import * as React from 'react';

export const AnswerStatusIcon = ({ correct }: { correct: boolean }) => {
  return correct ? (
    <CheckIcon color="positive" size={5} />
  ) : (
    <CrossIcon color="negative" size={5} />
  );
};
